import { Switch, SwitchProps } from '@mui/material';
import { InputHTMLAttributes, MouseEventHandler } from 'react';
import { getDeviceInfo } from 'state/localStorageTyped';

type SwitchControlProps = {
  disabled: boolean;
  checked: boolean;
  onChange: MouseEventHandler<HTMLButtonElement>;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  sx?: SwitchProps['sx'];
  /** MUI `edge="end"` for ListItem trailing alignment; disable in custom grid layouts. */
  listItemEdge?: boolean;
};

export const SwitchControl = (props: SwitchControlProps): JSX.Element => {
  const {
    disabled,
    checked,
    onChange,
    inputProps,
    sx,
    listItemEdge = true,
  } = props;
  const deviceInfo = getDeviceInfo();

  return (
    <Switch
      disabled={disabled}
      {...(listItemEdge ? { edge: 'end' as const } : {})}
      checked={checked}
      slotProps={inputProps ? { input: inputProps } : undefined}
      onClick={onChange}
      sx={
        // Native app webview, and web browser on iOS
        deviceInfo?.operatingSystem === 'ios'
          ? {
              ...(sx || {}),
              // @linear:ENG-2317 Fixes issue on iOS where switch backgrounds sometimes don't appear
              willChange: 'transform, opacity', // Forces GPU to render it properly
            }
          : sx
      }
    />
  );
};
